import { render, staticRenderFns } from "./BindS2cAccount.vue?vue&type=template&id=11c31a8a&"
import script from "./BindS2cAccount.vue?vue&type=script&lang=js&"
export * from "./BindS2cAccount.vue?vue&type=script&lang=js&"
import style0 from "./BindS2cAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports